import { Routes } from "@angular/router";

export const routes: Routes = [
	{
		path: "",
		loadComponent: () => import('./our-policies.component').then(m => m.OurPoliciesComponent),
		data: {
			title: "KudosHub | Our Policies",
			description:
				"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
			keywords: "kudoshub, policies, terms",
			ogTitle: "KudosHub | Our Policies",
			ogDesc:
				"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
			ogImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
			ogUrl: "https://kudoshub.com/our-policies",
			twitterTitle: "KudosHub | Our Policies",
			twitterDesc:
				"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
			twitterImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
		},
		children: [
			{
				path: "terms-of-service",
				loadComponent: () => import('./terms-of-service/terms-of-service.component').then(m => m.TermsOfServiceComponent),
				data: {
					title: "KudosHub | Our Policies",
					description:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					keywords: "kudoshub, policies, terms",
					ogTitle: "KudosHub | Our Policies",
					ogDesc:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					ogImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
					ogUrl: "https://kudoshub.com/our-policies",
					twitterTitle: "KudosHub | Our Policies",
					twitterDesc:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					twitterImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
				},
			},
			{
				path: "email-policy",
				loadComponent: () => import('./email-policy/email-policy.component').then(m => m.EmailPolicyComponent),
				data: {
					title: "KudosHub | Our Policies",
					description:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					keywords: "kudoshub, policies, terms",
					ogTitle: "KudosHub | Our Policies",
					ogDesc:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					ogImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
					ogUrl: "https://kudoshub.com/our-policies",
					twitterTitle: "KudosHub | Our Policies",
					twitterDesc:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					twitterImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
				},
			},
			{
				path: "privacy-policy",
				loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
				data: {
					title: "KudosHub | Our Policies",
					description:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					keywords: "kudoshub, policies, terms",
					ogTitle: "KudosHub | Our Policies",
					ogDesc:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					ogImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
					ogUrl: "https://kudoshub.com/our-policies",
					twitterTitle: "KudosHub | Our Policies",
					twitterDesc:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					twitterImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
				},
			},
			{
				path: "security",
				loadComponent: () => import('./security/security.component').then(m => m.SecurityComponent),
				data: {
					title: "KudosHub | Our Policies",
					description:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					keywords: "kudoshub, policies, terms",
					ogTitle: "KudosHub | Our Policies",
					ogDesc:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					ogImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
					ogUrl: "https://kudoshub.com/our-policies",
					twitterTitle: "KudosHub | Our Policies",
					twitterDesc:
						"We at KudosHub have created the policy and terms and conditions to show our commitment to our clients. You may read all the clauses carefully before signing up with us.",
					twitterImage: "https://kudoshub.com/theme/images/og-images/img07.webp",
				},
			},
			{ path: "", redirectTo: "terms-of-service", pathMatch: 'full' },
		],
	},
];